import { render, staticRenderFns } from "./PackagingBlock.vue?vue&type=template&id=3ba8dde2&scoped=true"
import script from "./PackagingBlock.vue?vue&type=script&lang=js"
export * from "./PackagingBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba8dde2",
  null
  
)

export default component.exports